import { connect } from 'react-redux';
import { Props } from './CollectionList';
import { selectors, CollectionStoreState, actions } from '../redux';
import { getSelectedFolderIds } from '../redux/selectors';

export type StateProps = Pick<
  Props,
  'streamId' | 'collections' | 'isFetching' | 'isInitialized' | 'selectedFolderIds'
>;
export type DispatchProps = Pick<Props, 'toggleCollection'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps = (
  state: CollectionStoreState,
  { collectibleDeviation: { deviationId }, isPrivateCollections }: OwnProps
): StateProps => ({
  ...selectors.getUserCollections(state, deviationId, isPrivateCollections),
  selectedFolderIds: getSelectedFolderIds(state, deviationId, isPrivateCollections),
});

const mapDispatchToProps: DispatchProps = {
  toggleCollection: actions.toggleCollection,
};

export default connect(mapStateToProps, mapDispatchToProps);
